import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useGetAuthUser from 'services/hooks/LoggedInUser/useGetAuthUser';
import PageLoader from './LoadingButton/PageLoader';
import {
  getFirstAllowedHomePath,
  isPathAllowedForUser,
  isPublicBrowsePath,
} from 'utils/dashboardPageAccess';

/**
 * Restricts /home/* child routes to pages selected for the logged-in member.
 */
export default function DashboardPageAccessGuard() {
  const location = useLocation();
  const { data: authRes, isLoading } = useGetAuthUser();
  const user = authRes?.data;
  const superAdmin = Boolean(user?.superAdmin);
  const rightsarray = user?.rightsarray;

  if (isLoading) {
    return <PageLoader />;
  }

  const pathname = location.pathname;

  // Guests (no logged-in member) may view public browse pages; the rights logic below
  // assumes a member and would otherwise bounce them away.
  if (!user && isPublicBrowsePath(pathname)) {
    return <Outlet />;
  }

  if (superAdmin) {
    return <Outlet />;
  }
  if (isPathAllowedForUser(pathname, rightsarray, superAdmin)) {
    return <Outlet />;
  }

  const fallback = getFirstAllowedHomePath(rightsarray, superAdmin);
  if (pathname !== fallback) {
    return <Navigate to={fallback} replace />;
  }

  return <Outlet />;
}
